import { API } from "./api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export function pushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

export async function isPushSubscribed() {
  if (!pushSupported()) return false;
  const reg = await navigator.serviceWorker.ready;
  return !!(await reg.pushManager.getSubscription());
}

// Subscribe THIS device to Web Push and save the subscription to the backend.
// Assumes Notification permission is already 'granted' by the caller.
export async function subscribeToPush() {
  if (!pushSupported()) return { ok: false, reason: "unsupported" };
  if (Notification.permission !== "granted") return { ok: false, reason: "denied" };
  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    const res = await fetch(`${API}/push/vapid-public-key`);
    const { public_key } = await res.json();
    if (!public_key) return { ok: false, reason: "no-key" };
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(public_key),
    });
  }
  await fetch(`${API}/push/subscribe`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ subscription: sub.toJSON() }),
  });
  return { ok: true };
}

export async function unsubscribeFromPush() {
  if (!pushSupported()) return { ok: false };
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    await fetch(`${API}/push/unsubscribe`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ endpoint: sub.endpoint }),
    }).catch(() => {});
    await sub.unsubscribe();
  }
  return { ok: true };
}

// Reliable device test: show a notification straight from the service worker (no server
// round-trip, not affected by the push-handler's "silent while open" rule). Proves the
// device/browser will actually display Cheapify notifications when permission is granted.
export async function showLocalTestNotification() {
  if (!pushSupported()) return { ok: false, reason: "unsupported" };
  if (Notification.permission !== "granted") {
    const p = await Notification.requestPermission();
    if (p !== "granted") return { ok: false, reason: "denied" };
  }
  const reg = await navigator.serviceWorker.ready;
  await reg.showNotification("🔔 Test from Cheapify", {
    body: "Your notifications are working! 🎉",
    icon: "/icon-192.png",
    badge: "/favicon-32x32.png",
    tag: "cheapify-test",
    data: { url: "/app" },
  });
  return { ok: true };
}
